var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 3H5.25C4.65326 3 4.08097 3.23705 3.65901 3.65901C3.23705 4.08097 3 4.65326 3 5.25V30.75C3 31.3467 3.23705 31.919 3.65901 32.341C4.08097 32.7629 4.65326 33 5.25 33H30.75C31.3467 33 31.919 32.7629 32.341 32.341C32.7629 31.919 33 31.3467 33 30.75V5.25C33 4.65326 32.7629 4.08097 32.341 3.65901C31.919 3.23705 31.3467 3 30.75 3Z",
    stroke: "#A464EE",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.29C11.4938 11.29 14.4937 9.79004 18 9.79004C21.5063 9.79004 24.5062 11.29 27 14.29",
    stroke: "#A464EE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.25C18.5967 23.25 19.169 23.0129 19.591 22.591C20.0129 22.169 20.25 21.5967 20.25 21C20.25 20.4033 20.0129 19.831 19.591 19.409C19.169 18.9871 18.5967 18.75 18 18.75C17.4033 18.75 16.831 18.9871 16.409 19.409C15.9871 19.831 15.75 20.4033 15.75 21C15.75 21.5967 15.9871 22.169 16.409 22.591C16.831 23.0129 17.4033 23.25 18 23.25Z",
    fill: "#A464EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 15.75L18.006 21",
    stroke: "#A464EE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.694f6bd47a0d24ce263efaa3963c70e2.svg";
export { ForwardRef as ReactComponent };